import React, { Component }  from 'react';
import del from '../img/delete.svg';
import plus from '../img/plus.svg';


class SayAS extends Component {constructor(props) {
		super(props);
		this.state = { 
			active: false, 
			editing: false,
			loading: false,
		};
	}
	
	add = () => {
		this.setState({editing: true, loading: false, rep:{}})
	}
	
	edit = (rep) => (e) => {
		console.log(rep)
		this.setState({editing: true, loading: false, rep: rep})
	}
	editHeard =(e)=> {
		this.setState({editing: true, loading: false, rep:{provided: e.currentTarget.value , replace: this.state.rep.replace }})
	}
	
	editSubmit=(e)=> {
		this.setState({editing: true, loading: false, rep:{provided: this.state.rep.provided, replace: e.currentTarget.value }})
	}
	conf =()=>{
		this.setState({loading: true})
		this.props.ws.send(JSON.stringify({route: 'addSayAs', rep: this.state.rep }))		
		
	}
	deleteExclusion = (rep) => (e) => {
		this.props.ws.send(JSON.stringify({route: 'deleteSayAs', rep: rep }))	
	}
	
	cancel = () => {
		this.setState({editing: false, loading: false, setting: false})
	}
	
	
	
	componentWillReceiveProps(nextProps) {
		if(this.state.loading) {
			this.cancel();
		}
	}
	render() {
		if (this.props.active) {	
			var exclusions = []
				for (var rep of this.props.data.SayAs) {
					exclusions.push(
						<div className="dataRow" key={rep.provided}>
							<span style={{flex: '0 0 300px'}} onClick={this.edit(rep)}>{rep.provided}</span>
							<span style={{flex: '1 0 20%', textAlign: 'center'}} onClick={this.edit(rep)} >{rep.replace}</span>
							<span className="buttonBox" style={{flex: '0 0 280px'}}>
								<img src={del} alt="Delete Exclusion" onClick={this.deleteExclusion(rep)} />
							</span>
							
						</div>
					)
				}
			var edit = ""
			if (this.state.editing) {
				edit = (
					<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
						<div className="pop" >
							<div className="viewCloser" onClick={this.cancel}>X</div>
							
							<div className="snazzyInputBox">
								<input className="textInput" type="text" required value={this.state.rep.provided} onChange={this.editHeard} ></input>
								<span className="inputBar"></span><label className="textLabel">Word/Phrase</label>
							</div>
							
							<div className="snazzyInputBox">
								<input className="textInput" type="text" required value={this.state.rep.replace} onChange={this.editSubmit} ></input>
								<span className="inputBar"></span><label className="textLabel">Say As...</label>
							</div>
							
							
							<div className="error" style={{padding: '15px'}}>{this.state.error}</div>
							
							{this.state.loading ? <div className="loader"></div> : <div className="button"  onClick={this.conf}>Confirm Say As Replacement</div>}
						</div>
					</div>
				)
			}	
			return (
				<div className="viewContent" id="reportView" >
					<img src={plus}  className="plusButton" alt="Add" onClick={this.add} />
					<div className="dataHeaders">
						<span style={{flex: '0 0 300px', cursor: 'pointer'}} onClick={this.sort} data-sortby="name">Word/Phrase</span>
						<span style={{flex: '1 0 20%', cursor: 'pointer'}} onClick={this.sort} data-sortby="modified">Say As...</span>
						<span style={{flex: '0 0 330px'}}></span>
					</div> 
					<div style={{overflow: 'auto', height: 'calc(100% - 85px)'}}>
						{exclusions}
						{edit}
					</div>
				</div>
			);
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}
}

export default SayAS


// WEBPACK FOOTER //
// ./src/Views/SayAs.js